import { useEffect } from "react";

/**
 * A global hook that listens for interaction with `.press-scale` elements
 * and triggers a short native haptic vibration if supported by the device.
 */
export function useGlobalHaptics() {
    useEffect(() => {
        const handlePointerDown = (e: PointerEvent) => {
            const target = e.target as HTMLElement;
            // If the user tapped on an element with the .press-scale class (or a child of it)
            if (target.closest('.press-scale')) {
                // Trigger a very light haptic tick
                if (typeof navigator !== 'undefined' && navigator.vibrate) {
                    navigator.vibrate(15);
                }
            }
        };

        // Use pointerdown to capture both mouse clicks and touch events instantly
        document.addEventListener("pointerdown", handlePointerDown, { passive: true });

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
        };
    }, []);
}
